import { useState, useCallback } from 'react';

export function useBatchSelection(items = [], extractId = (item) => item.id) {
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [isSelectionMode, setIsSelectionMode] = useState(false);

  const toggleSelection = useCallback((id) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
        if (next.size === 0) setIsSelectionMode(false);
      } else {
        next.add(id);
        setIsSelectionMode(true);
      }
      return next;
    });
  }, []);

  const selectAll = useCallback(() => {
    if (items.length === 0) return;
    
    if (selectedIds.size === items.length) {
      setSelectedIds(new Set());
      setIsSelectionMode(false);
    } else {
      const allIds = items.map(extractId);
      setSelectedIds(new Set(allIds));
      setIsSelectionMode(true);
    }
  }, [items, selectedIds.size, extractId]);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
    setIsSelectionMode(false);
  }, []);

  const startSelection = useCallback((initialId) => {
    setIsSelectionMode(true);
    if (initialId) {
      setSelectedIds(new Set([initialId]));
    }
  }, []);

  return {
    selectedIds,
    isSelectionMode,
    toggleSelection,
    selectAll,
    clearSelection,
    startSelection,
    selectedCount: selectedIds.size,
    totalCount: items.length
  };
}
